import script from "./Agreement.vue?vue&type=script&lang=ts&setup=true"
export * from "./Agreement.vue?vue&type=script&lang=ts&setup=true"

import "./Agreement.vue?vue&type=style&index=0&id=5987af2c&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5987af2c"]])

export default __exports__